import { render, staticRenderFns } from "./ProductIconReveal.vue?vue&type=template&id=13967f09&scoped=true&"
import script from "./ProductIconReveal.vue?vue&type=script&lang=js&"
export * from "./ProductIconReveal.vue?vue&type=script&lang=js&"
import style0 from "./ProductIconReveal.vue?vue&type=style&index=0&id=13967f09&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13967f09",
  null
  
)

export default component.exports